import { render, staticRenderFns } from "./NewBannerSidebar.vue?vue&type=template&id=81c6e878"
import script from "./NewBannerSidebar.vue?vue&type=script&lang=js"
export * from "./NewBannerSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports